export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function getToken() {
  const token = `${getCookie("access")}`;
  return token;
}

export function concatPathWithParams(path, queryParams) {
  let pathWithParams = path;

  if (queryParams && Object.keys(queryParams).length) {
    pathWithParams += `?${_queryParamsToQueryString(queryParams)}`;
  }

  return pathWithParams;
}

function _queryParamsToQueryString(queryParams) {
  return Object.keys(queryParams)
    .filter((key) => queryParams[key] !== undefined)
    .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
    .join("&");
}

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export function setCookies(response) {
    // Start from an empty jar. Permissions are read from cookies rather than the token, so a
    // leftover `${group}=true` from the previous user grants their access to this one. Clearing
    // wholesale rather than deleting a known list of group names is deliberate: the names come
    // from the server, and any list hardcoded here would rot silently the next time one is
    // added. Every cookie in this estate is session-derived, so none of them should outlive a
    // login — that includes client_id/location_id/installer_company_id, which had the same bug
    // in a quieter form, being written only when present and otherwise left at the old value.
    clearAllCookies();

    const assigned_user_groups = parseJwt(response.access).user_groups;
    const client_id = parseJwt(response.access).client_id
    const location_id = parseJwt(response.access).location_id
    const installer_company_id = parseJwt(response.access).installer_company_id

    const domain = process.env.REACT_APP_SECRET_DOMAIN;
    const domainAttr = domain && domain !== 'localhost' ? `domain=${domain};` : '';

    document.cookie = `refresh=${response.refresh};max-age=86400;${domainAttr}path=/`;
    document.cookie = `access=${response.access};max-age=57600;${domainAttr}path=/`;

    if(client_id){
      document.cookie = `client_id=${client_id};max-age=57600;${domainAttr}path=/`;
    }
    if(location_id){
      document.cookie = `location_id=${location_id};max-age=57600;${domainAttr}path=/`;
    }
    if(installer_company_id){
      document.cookie = `installer_company_id=${installer_company_id};max-age=57600;${domainAttr}path=/`;
    }
    assigned_user_groups.forEach((group) => {
        document.cookie = `${group}=true;max-age=57600;${domainAttr}path=/`;
    });

}

export function clearAllCookies() {
  const domain = process.env.REACT_APP_SECRET_DOMAIN;
  const domainAttr = domain && domain !== 'localhost' ? `domain=${domain};` : '';
  const EXPIRED = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';

  for (const cookie of document.cookie.split(';')) {
    const eqPos = cookie.indexOf('=');
    // split(';') leaves a leading space on every entry after the first. Browsers trim it when
    // parsing a name, so this works either way, but trimming makes that not depend on it.
    const name = (eqPos > -1 ? cookie.substring(0, eqPos) : cookie).trim();
    if (!name) continue;
    // Expire it both ways. Against a real domain, `domain=X` and host-only are two distinct
    // cookies that can share a name, and clearing one would leave the other behind.
    document.cookie = `${name}=;${EXPIRED};path=/`;
    if (domainAttr) document.cookie = `${name}=;${EXPIRED};${domainAttr}path=/`;
  }
}
